import React from 'react';
import PropTypes from 'prop-types';
import looppa from 'looppa';
import Button from 'components/button';

export default function ButtonsGroup({ actions, className }) {
    return (
        <div className={className}>
            {looppa(actions)(({ name, event, ...props }, i) => (
                <Button
                    key={i}
                    { ...props }
                    onClick={event}>
                    { name }
                </Button>
            ))}
        </div>
    );
}

ButtonsGroup.propTypes = {
    className: PropTypes.string.isRequired,
    actions: PropTypes.arrayOf(PropTypes.shape({
        name: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
        event: PropTypes.func.isRequired,
    })).isRequired,
};



// WEBPACK FOOTER //
// ./mcart/assets/src/js/app/components/buttons-group/index.js